import React from 'react'
import PropTypes from 'prop-types'

export default function SelectMultiGenericOptionPill(props) {
    if (!props.option) return false

    const onClick = (e) => {
        e.stopPropagation()
        if(props.onClick) props.onClick(props.option)
    }

    const onDelete = (e) => {
        e.stopPropagation()
        if(props.onDelete) props.onDelete(props.option)
    }

    const optionColor = _.get(props.option, 'color', null) //!_.isNil(option.color) ? option.color : null;

    const pillClasses = Classes("ui5-pillbox", "s{0}".f(props.size), "m-t-4", "m-b-4", props.className, {
        'default-color'                     : !optionColor,
        ['gd-c-bgp-'+optionColor]           : !!optionColor,
        ['gd-c-pale-border-'+optionColor]   : !!optionColor
    });

    return (
        <div className={pillClasses} style={props.style} onClick={props.onClick ? onClick : null}>
            {props.option.label}
            {props.onDelete && <div className="delete-button centered ui5-ico-delete s14 gray" onClick={onDelete}/>}
        </div>
    );
}

SelectMultiGenericOptionPill.propTypes = {
    size        : PropTypes.oneOf(['26', '22']),
    option      : PropTypes.object,

    onClick     : PropTypes.func,
    onDelete    : PropTypes.func
}

SelectMultiGenericOptionPill.defaultProps = {
    size        : '26'
}